import { createContext, useEffect, useMemo, useState } from "react";

const CheckoutContext = createContext();

const EMPTY_VALUES = {
  motorreservanombretitular: "",
  motorreservaapellidotitular: "",
  reservanombre: "",
  reservatipodocumento: "",
  reservadocumento: "",
  reservatelefono: "",
  correoElectronico: "",
  reservadireccion: "",
  reservafechanacimiento: null,
  reservapais: "",
  reservaobservaciones: "",
  reservaautocolor: "",
  reservaautomarca: "",
  reservaautomatricula: "",
};

// Helpers seguros
const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const CheckoutProvider = ({ children }) => {
  // ✅ SOLO cargar lo guardado si existe y es válido
  const initialValues = useMemo(() => {
    const saved = safeParse(localStorage.getItem("checkoutForm"));
    return saved && typeof saved === "object" ? { ...EMPTY_VALUES, ...saved } : EMPTY_VALUES;
  }, []);

  const [formValues, setFormValues] = useState(initialValues);

  // Nuevo: RUT del cliente (cuando corresponda)
  const [rutCliente, setRutCliente] = useState("");

  // Nuevo: Saber si el hotel usa Lectura RUT
  const [showLecturaRut, setLecturaRut] = useState(false);

  // ✅ Guardar con debounce (evita escribir 200 veces por segundo)
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem("checkoutForm", JSON.stringify(formValues));
      } catch (e) {
        // si el storage está lleno o bloqueado, no rompo el flujo
        console.warn("No se pudo guardar checkoutForm en localStorage:", e);
      }
    }, 250);

    return () => clearTimeout(t);
  }, [formValues]);

  // ✅ Reset “real”: borra form + flags + marcas de reservas procesadas
  const resetCheckout = () => {
    setFormValues(EMPTY_VALUES);
    setRutCliente("");
    setLecturaRut(false);

    try {
      localStorage.removeItem("checkoutForm");

      // Limpio cualquier marca de "reservaMotorProcesada_*"
      // para evitar que una PC “reutilice” estados viejos
      Object.keys(localStorage).forEach((k) => {
        if (k.startsWith("reservaMotorProcesada_")) localStorage.removeItem(k);
      });

      // Si usás estas otras keys en Checkout.js, también conviene limpiar:
      localStorage.removeItem("checkoutStep");
      localStorage.removeItem("reservaEnMotor");
    } catch (e) {
      console.warn("No se pudo limpiar localStorage en resetCheckout:", e);
    }
  };

  return (
    <CheckoutContext.Provider
      value={{
        formValues,
        setFormValues,
        rutCliente,
        setRutCliente,
        showLecturaRut,
        setLecturaRut,
        resetCheckout,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export default CheckoutContext;
